module.exports = __webpack_public_path__ + "static/media/winfile_2.51c94901.ico";